/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/frequency_capping_coverage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationFrequencyCappingCoverage } from "./constants";
import type { GetMessagePrioritizationFrequencyCappingCoverageResult } from "./types";
import { isGetMessagePrioritizationFrequencyCappingCoverageResult } from "./validators";

/**
 * GET handler for the "/app_settings/:app_group_id/message_prioritization/frequency_capping_coverage" endpoint
 *
 * Takes the object's attributes rather than its id: the launch tray has to reflect what the
 * marketer is about to launch, which may be an unsaved edit or a post-launch draft, so a stored
 * Campaign/Canvas would be the wrong thing to evaluate.
 */
export const getMessagePrioritizationFrequencyCappingCoverage = reactQueryFetcherAdapter(
  appSettingsAppGroupIdMessagePrioritizationFrequencyCappingCoverage,
  (
    signal: AbortSignal,
    appGroupId: string,
    channels: string[],
    tagNames: string[],
    categoryId: string
  ): Promise<GetMessagePrioritizationFrequencyCappingCoverageResult> => {
    return fetch(
      `/app_settings/${appGroupId}/message_prioritization/frequency_capping_coverage`,
      "GET",
      { channels, tag_names: tagNames, category_id: categoryId },
      { signal },
      {
        // fail-open background check: do not display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  },
  isGetMessagePrioritizationFrequencyCappingCoverageResult
);
